<script>
import resources from './resources'

export default {
  name: 'gadget-staff',

  mixins: [resources]
}
</script>

<template lang="pug">
  section.content.home
    .container-fluid
      .block-header
        .row.clearfix
          .col-lg-5.col-md-5.col-sm-12
            h2 Dashboard
            ul.breadcrumb.padding-0
              li.breadcrumb-item
                a(href='index.html')
                  i.zmdi.zmdi-home
              li.breadcrumb-item.active Dashboard
          //-.col-lg-7.col-md-7.col-sm-12
            .input-group.m-b-0
              input.form-control(type='text', placeholder='Search...')
              span.input-group-addon
                i.zmdi.zmdi-search
      .row.clearfix
        .col-lg-3.col-md-6
          .card.text-center
            .body
              p.m-b-20
                i.zmdi.zmdi-balance.zmdi-hc-3x.col-amber
              span Total Unidades
              h3.m-b-10
                span.number.count-to
                  count-to(:startVal='0' separator="" :endVal='Number(statistics.units)' :duration=4000)
        .col-lg-3.col-md-6
          .card.text-center
            .body
              p.m-b-20
                i.zmdi.zmdi-car.zmdi-hc-3x.col-blue
              span Total Veículos
              h3.m-b-10.number.count-to
                count-to(:startVal='0' separator="" :endVal='Number(statistics.cars)' :duration=4000)
        .col-lg-3.col-md-6
          .card.text-center
            .body
              p.m-b-20
                i.zmdi.zmdi-repeat.zmdi-hc-3x
              span Empréstimo de Vagas
              h3.m-b-10.number.count-to
                count-to(:startVal='0' separator="" :endVal='Number(statistics.parkingLoans)' :duration=4000)
        .col-lg-3.col-md-6
          .card.text-center
            .body
              p.m-b-20
                i.zmdi.zmdi-account-box.zmdi-hc-3x.col-green
              span Total Inquilinos
              h3.m-b-10.number.count-to
                count-to(:startVal='0' separator="" :endVal='Number(statistics.tenants)' :duration=4000)
</template>



// WEBPACK FOOTER //
// src/app/dweller/dashboard/gadget/index.vue